import HowToPlayListItem from "app/ui/HowToPlayListItem";
import TypoWord from "app/ui/TypoWord";
import cn from "app/utils/classnames";

export default function getSpeedInstructions(): React.ReactNode {
  return (
    <ul className={cn("list-disc", "pl-4", "flex flex-col gap-2")}>
      <HowToPlayListItem key={0}>
        <TypoWord word="Spell" /> the words <TypoWord word="correctly" />, as
        quickly as <TypoWord word="possible" />.
      </HowToPlayListItem>
      <HowToPlayListItem key={1}>
        Score points for <TypoWord word="correct" />{" "}
        <TypoWord word="spelling" />, streaks, and speed.
      </HowToPlayListItem>
    </ul>
  );
}
